import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Panel } from 'components/ui/index';
import { SearchFieldFilter, Permission } from 'components/page/index';
import { addToSelection, resetFilterValue } from 'components/page/ObjectFilter/components/FieldsSelection/flow/actions';
import PERMISSIONS from 'config/app-permission.config';
import { fetchObjectAllFields, updateModuleColumnsByType } from '../flow/action';

const propTypes = {
  objectType: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  panelTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};
const defaultProps = {};

const LayoutModule = ({
  objectType,
  theme,
  panelTitle,
  searchLayout,
  isDefaultField,
  fetchObjectAllFields,
  addToSelection,
  updateModuleColumnsByType,
  selectedFields,
  resetFilterValue
}) => {
  const actionRight = (
    <Permission permission={PERMISSIONS.SETUP_GENERALSETTINGS_SEARCHLAYOUT_UPDATE}>
      <SearchFieldFilter
        theme={theme}
        objectType={objectType}
        fetchObjectAllFields={fetchObjectAllFields}
        searchLayout={searchLayout[objectType]}
        addToSelection={addToSelection}
        updateModuleColumnsByType={updateModuleColumnsByType}
        selectedFields={selectedFields}
        isDefaultField={isDefaultField}
        resetFilterValue={resetFilterValue}
        needRestore={false}
      />
    </Permission>
  );

  return (
    <Panel
      panelClasses={`${theme}-theme-panel`}
      contentClasses="pb-md"
      panelTitle={panelTitle}
      actionsRight={actionRight}
    >
      <table style={{ width: '100%' }}>
        <thead className="ant-table-thead">
          <tr>
            {_.isArray(searchLayout[objectType]) &&
              searchLayout[objectType].map(m =>
                <th key={m.id}>{m.field_label}</th>
              )
            }
          </tr>
        </thead>
      </table>
    </Panel>
  );
};

LayoutModule.propTypes = propTypes;
LayoutModule.defaultProps = defaultProps;

const mapStateToProps = ({ setup, objectView }) => {
  const { fields } = objectView;
  return {
    searchLayout: setup.searchLayout,
    selectedFields: fields.selectedFields,
    isDefaultField: fields.isDefaultField,
  };
};

const mapDispatchToProps = {
  fetchObjectAllFields,
  addToSelection,
  resetFilterValue,
  updateModuleColumnsByType
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutModule);



// WEBPACK FOOTER //
// ./src/views/Setup/SearchLayout/component/searchLayoutModule.jsx